import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VerticalDistributeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vertical_distribute"}/>
}
